<template>
  <div class="staff_login">
    <div class="loginContent">
      <el-form class="loginForm" :model="{}">
        <img src="@img/newCode/userLogin/login_back.jpg" />
        <div class="login">
          <h2>员工登录</h2> 
          <k-input id="userName"  placeholder="请输入您的账号" :value.sync="userName"   
           @keydown.native.enter="showSlider"  validtype="length[1,256]|max[11]"   />

           <k-input id="password" placeholder="请输入您的密码" :value.sync="password"   
           @keydown.native.enter="showSlider"  validtype="password"   />

          <div class="error">
            <div v-show="errorText">
              <span class="errorIcon">×</span>{{ errorText }}
            </div>
          </div>
          <div class="loginBtn" @click="showSlider">立即登录</div>
          <!-- <div class="applyBtn" @click="changeToOld">
	          <span>切换到旧平台</span>
	        </div> -->
        </div>
      </el-form>
      
      <k-dialog
      class="showModal" 
      ref="sendMessageDialog"
      :options="{
        title:'请输入手机验证码',
        center: true,
        width: '20%',
        top: '0',
        destroyOnClose: false,
        isCanClickClose: false,
        onCloseBefore: cancel, 
        showClose: true, 
        buttons: [
          { text: '取消', handler: cancel },
          { text: '确定', handler: ok }
        ]
      }"
    >
        <el-form class="phone-style">
          <k-input id="maskedPhone"  placeholder="请输入您的手机号码" :disabled = "true" :value.sync="maskedPhone"   
           @keydown.native.enter="showSlider"  validtype="length[1,256]|max[11]"   />

           <k-input id="phoneCheckCode" ref="phoneCheckCodeRef" placeholder="请输入您的手机验证码" :value.sync="phoneCheckCode"   
           @keydown.native.enter="showSlider"  validtype="length[6,6]|max[6]"  :clickButton="getPhoneCode" :buttontxt="phoneCodeText" />
        </el-form>
    </k-dialog>
 
    <k-dialog
          class="morePeopleLogin-style"
          ref="morePeopleLoginRef"
          :options="{
            title:'提示',
            center: true,
            width: '30%',
            top: '0',
            destroyOnClose: true,
            isCanClickClose: false,
            showClose: true, 
            onCloseBefore: replaceCancel, 
            buttons: [
              { text: '取消', handler: replaceCancel },
              { text: '确定', handler: replaceOk }
            ]
          }"
        >
        <p>您的账号已在其它地方登陆, 是否继续登陆</p>
    </k-dialog>

      <slider-validator
        ref="slider"
        :visible="slider_flag"
        :bigImage="sliderInfo.bigImage"
        :smallImage="sliderInfo.smallImage"
        :yHeight="sliderInfo.yheight"
        :sliderDisabled="sliderDisabled"
        @refreshImg="refreshImg"
        @closeIconClick="closeIconClick"
        @slideEnd="slideEnd"
      />
    </div>
    <v-footer />
  </div>
</template>

<script>
import VFooter from "@/components/common/footer";
import kInput from "@/components/baseUI/kInput";
import kDialog from "@/components/common/dialog.vue";
import { mapMutations } from "vuex";
import { JSEncrypt } from "jsencrypt";
import Util from "@old/commonTools/util.js";
import sliderValidator from "@old/components/slider-validator/slider-validator";
import oppService from "@/service/opp-service";
import logObj from "@/tools/logSystem/log";
let sdes = require("@/tools/libs/standard-des");

export default {
  components: {
    kInput,
    kDialog,
    VFooter,
    sliderValidator
  },
  data () {
    return {
      userName: "",
      password: "",
      errorText: "",
      checkCode: "", //手机验证码
      codeUrl: "", //验证码图片
      publicKey: "", //公钥
      code: Util.getCode(6), //随机数
      sliderInfo: {}, //滑块信息
      slider_flag: false, //滑块显示隐藏
      serial: "", //滑块ID
      sliderDisabled: false, //是否禁用滑动滑块 
      phoneNumber: "", //手机号码
      maskedPhone: "", //隐藏式手机号码
      phoneCheckCode: "", //手机号验证码
      phoneCodeText: "获取验证码",
      loading: true, //加载 
      getPhoneCodeFlag: false
    };
  },
  mounted () {
    clearInterval(window.checkMobileInterval);
    window.checkMobileInterval = null;
    // this.logout();
    this.getPublicKey(); 
    this.$store.commit(this.$types.UPDATE_USER_INFO, null);
    //清除系统参数
    this.$storage.removeLocal(this.$definecfg.SYS_COMM_PARAM_OBJS);
    //清除字段缓存
    this.$storage.removeLocal(this.$definecfg.SYS_DICT_CACHE);
  },
  methods: {
    ...mapMutations(["UPDATE_WITNESS_AUTH","UPDATE_EDIT_AUTH","UPDATE_CHECK_AUTH"]),
    // logout (){
    //   if(this.$store.state.token){
    //     //返回登录页面，应该主动退出登录
    //     this.$syscfg.K_Request("F0000003",{}).then(res => {
    //       if (res.Code == 0) {
    //         this.$store.commit(this.$types.UPDATE_TOKEN, "");
    //         this.$store.commit(this.$types.UPDATE_USER_INFO, "");
    //         this.$router.push("/userLogin");
    //       }
    //     });
    //   }
    // },
    replaceOk () {
      //关闭手机号码验证框
      this.$refs.sendMessageDialog.open();
      this.getPhoneCode();
    },
    replaceCancel () { 
      //新版，闭已登录的框
      this.$refs.morePeopleLoginRef.close();

      //关闭手机号码验证框
      this.$refs.sendMessageDialog.close();
      this.slider_flag = false;
    },
    async getPublicKey () {
      this.$store.commit(this.$types.UPDATE_LOADING, "获取数据中");
      let res = await this.$syscfg.K_Request("F0000007");
      consoleLog("publicKey", res);
      if (res.Code == 0) {
        this.publicKey = res.Data[0] || "";
        this.$store.commit(this.$types.UPDATE_LOADING, false);
        return Promise.resolve(true);
      }else{
        this.alert("参数获取失败" + res.Msg);
        return Promise.resolve(false);
      }
    },
    //获取滑块信息
    async getImageVerifyCode () {
      let res = await this.$syscfg.K_Request("F0000009");
      if (res.Code == 0) {
        if (res.Data[0]) {
          this.sliderInfo = res.Data[0].sliderCode;
          this.$refs.slider.closeLoading();
        }
      } else {
      }
    },
    //刷新滑块
    refreshImg () {
      this.getImageVerifyCode();
    },
    //关闭滑块
    closeIconClick () {
      this.slider_flag = false;
    },
    //滑块滑动完毕
    slideEnd (x) {
      this.checkCode = x;
      this.sliderDisabled = true;
      this.$refs.slider.showLoadingFn();
      this.login(); 
    },
    showSlider () {
      if (!this.userName) {
        this.errorText = "请输入您的账号";
        return;
      }
      if (!this.password) {
        this.errorText = "请输入您的密码";
        return;
      } 

      this.getImageVerifyCode();
      this.slider_flag = true;
      this.sliderDisabled = false;
    },
    login () {
      if (!this.publicKey) {
        this.getPublicKey().then(flag => {
          if (flag) {
            this.login();
          }
        });
        return;
      }
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey(this.publicKey.publickey);
      // 加密密码
      let password = encrypt.encrypt(this.password);
      if (!password) {
        this.alert("登录失败，请联系管理员！");
        return;
      }

      this.errorText = "";
      this.$syscfg
        .K_Request("F0000008", {
          userName: this.userName,
          passWord: password,
          checkCode: this.checkCode,
          code: this.sliderInfo.serial
        }, true, true)
        .then(res => {
          if (res.Code == "0") {
            let data = res.Data[0];
            this.phoneNumber = data.phoneNumber;
            this.maskedPhone = data.maskedPhone;
            this.phoneCheckCode = data.code;
 
            this.loginFlag = true; //是否已经调用过webLogin
            if (data.logined) { 
              //新版本，弹出已登录提示框 
              this.$refs.morePeopleLoginRef.open();
              return;
            }
            this.$refs.slider.success();
            setTimeout(() => { 
              //弹出手机号码验证框
              this.$refs.sendMessageDialog.open();
              this.countDown();
              // this.alert( "已向该手机发送验证码，请在手机查看！");
            }, 1000);
          } else if (res.Code == 10001) {
            this.$refs.slider.errorTip(res.Msg || "验证失败，请重试！");
            setTimeout(() => {
              this.sliderDisabled = false;
              this.slider_flag = false;
            }, 1000); 
          }else if(res.Code == -1){
            if(res.Msg.includes("权限")){
              this.$refs.slider.errorTip("您无权登录，请先进行权限申请。");
              this.errorText = " 您无权登录，请先进行权限申请。";
            }else{
              this.$refs.slider.errorTip("登录失败, " + res.Msg.replace("PC端登录接口调用失败,提示信息:","").replace("【","").replace("】",""));
              this.errorText = "登录失败, " + res.Msg.replace("PC端登录接口调用失败,提示信息:","").replace("【","").replace("】","");
            }
            setTimeout(() => {
              this.sliderDisabled = false;
              this.slider_flag = false;
            }, 500);
          }else if(res.Code == -1008){
            this.errorText = "验证失败，请重试！";
            if(res.Msg.includes("发送短信服务调用失败")){
              this.errorText = "验证失败，短信服务异常！";
            }else if(res.Msg.includes("PC端登录接口调用失败")){
              this.errorText = res.Msg;
            }
            this.$refs.slider.errorTip(this.errorText);
            setTimeout(() => {
              this.sliderDisabled = false;
            }, 1000);
          }else  {
            this.$refs.slider.errorTip(res.Msg || "验证失败，请重试！");
            setTimeout(() => {
              this.sliderDisabled = false;
            }, 1000);
            this.errorText = res.Msg || "登录失败！";
          }
        });
    },
    //获取手机验证码
    async getPhoneCode () {
      if (this.getPhoneCodeFlag) {
        return;
      }
      this.phoneCodeText = "发送中...";
      this.getPhoneCodeFlag = true;
      let data = {
        phoneNumber: this.phoneNumber
      };
      try {
        let res = await this.$syscfg.K_Request("F0000002", data);
        if (res.Code =="0" ) {
          this.getPhoneCodeFlag = false;
          this.phoneCheckCode = res.Data[0].code;
      
          if (this.loginFlag) {
            this.$refs.slider.success();
            setTimeout(() => { 
              //弹出手机号码验证框
              this.$refs.sendMessageDialog.open();
              this.countDown();
              // this.alert("已向该手机发送验证码，请在手机查看！");
            }, 1000);
            return;
          }
          this.countDown();
          // this.alert("已向该手机发送验证码，请在手机查看！");
        } else if (res.data.errorcode === 10001) {
          this.password = "";
          this.loading = false;
          this.alert(res.data.msg || "登录超时"); 
          //关闭手机号码验证框
          this.$refs.sendMessageDialog.close();
          this.slider_flag = false;
          this.sliderDisabled = false;
          this.loginFlag = false;
          this.phoneCodeText = "获取验证码";
        } else {
          this.getPhoneCodeFlag = false;
          this.alert(res.Msg || "验证码获取失败，请重试");
          if (this.loginFlag) {
            this.sliderDisabled = false;
            this.$refs.slider.closeLoading();
            this.$refs.slider.refreshImg();
            return;
          }
          setTimeout(() => {
            this.phoneCodeText = "重新获取";
          }, 500);
        }
      } catch (err) {
        setTimeout(() => {
          this.getPhoneCodeFlag = false;
          this.phoneCodeText = "重新获取";
        }, 1000);
      }
    },
    //短信验证
    async MSLogin () {
      if (!this.phoneNumber) {
        this.alert("手机号码为空，请重试！");
        return false;
      }
      if (!this.phoneCheckCode) {
        this.alert("验证码不能为空！");
        return false;
      }
      let data = {
        phoneNumber: this.phoneNumber,
        code: this.phoneCheckCode
      };
      this.UPDATE_WITNESS_AUTH(false);
      this.UPDATE_EDIT_AUTH(false);
      let res = await this.$syscfg.K_Request("F0000010", data, true, true);
      if (res.Code === "0") { 
      //弹出手机号码验证框 
        this.$refs.sendMessageDialog.close();
        this.$store.commit(this.$types.UPDATE_TOKEN, res.Data[0].token);
        let userInfo = res.Data[0].userInfo;
        //拥有见证权限
        if(userInfo.witnessPost === "true"){
          this.UPDATE_WITNESS_AUTH(true);
        }
        //拥有操作员权限,就只能查看普通数据
        if(userInfo.operatePost === "true"){
          this.UPDATE_CHECK_AUTH(true);
        }
        //拥有运营岗权限跟见证岗权限，才有修改权限
        if(userInfo.operatePost === "true" && userInfo.witnessPost === "true"){
          this.UPDATE_EDIT_AUTH(true);
        }
        
        this.$store.commit(this.$types.UPDATE_USER_INFO, userInfo);
        await oppService.getSysCommonParamsFromCacheObjs("FXC_LOG_MAX_ERROR_NUM");
        await oppService.getSysCommonParamsFromCacheObjs("FXC_IS_COLLECT_LOG");
        logObj.changeLogParam();
        setTimeout(() => {
          this.$router.push("/businessList");
        }, 500);
        return true;
      } else if (res.Code === 10001) {
        this.password = "";
        this.loading = false;
        this.alert(res.data.msg || "登录超时");
   
        //关闭手机号码验证框
        this.$refs.sendMessageDialog.close();
        this.slider_flag = false;
        this.sliderDisabled = false;
        this.loginFlag = false;
        this.phoneCodeText = "获取验证码";
        return false;
      } else {
        this.loading = false;
        this.alert(res.Msg || "短信验证失败，请重试");
        setTimeout(() => {
          this.loading = true;
        }, 100);
        return false;
      }
    },
    //倒计时
    countDown () {
      this.getPhoneCodeFlag = true;
      let num = 60;
      this.phoneCodeText = num + "s";
      this.phoneCodeTimer = setInterval(() => {
        num -= 1;
        if (num <= 0) {
          this.getPhoneCodeFlag = false;
          this.phoneCodeText = "重新获取";
          clearInterval(this.phoneCodeTimer);
          return;
        }
        this.phoneCodeText = num + "s";
      }, 1000);
    },
    ok () {
      return this.MSLogin();
    },
    // async changeToOld (){
    //切换到旧版本
    //   let webUrl = await oppService.getSysCommonParamsFromCacheObjs("FXC_OLD_WEB_URL");
    //   if(!webUrl){
    //     alert("系统参数为空，请联系管理员！");
    //     return;
    //   } 
    //   window.location.href = webUrl;
    // },  
    cancel () {
      this.$refs.sendMessageDialog.close();
      this.sliderDisabled = false;
      this.$refs.slider.closeLoading();
      this.$refs.slider.refreshImg();
      clearInterval(this.phoneCodeTimer);
      this.getPhoneCodeFlag = false; 
    } 
  }
};
</script>
<style lang="less" scoped>
.loginContent {
  // position: relative;
  width: 100%;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 60px;
  bottom: 60px;
  /deep/ .loginForm{
    height:100%;
    img{
      height:100%;
    }
  }
}
.loginContent img {
  width: 100%;
  display: block;
}
.login {
  position: absolute;
  right: 3rem;
  width: 5rem;
  height: 4.9rem;
  background: #ffffff;
  top: 50%;
  margin-top: -2.45rem;
  box-sizing: border-box;
  padding: 0 0.75rem;
}
.login h2 {
  text-align: center;
  font-size: 0.28rem;
  font-weight: normal;
  line-height: 0.4rem;
  margin: 0.31rem 0;
}
.input {
  height: 0.5rem;
}

.login .null {
  border: 0.01rem solid red;
  border-radius: 0.05rem;
}

.phone-style{
  margin-left: 40px;
  margin-right: 40px;
  margin-top: 22px;
}
.morePeopleLogin-style{
  p{
    padding: 16px;
  }
}

.error {
  color: #f24646;
  height: 0.3rem;
  line-height: 0.3rem;
  margin-bottom: 0.2rem;
  font-size: 0.12rem;
}
.errorIcon {
  width: 0.12rem;
  height: 0.12rem;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  line-height: 0.12rem;
  background: #f24646;
  color: #ffffff;
  font-size: 0.12rem;
  margin-right: 0.08rem;
}
.loginBtn {
  display: block;
  height: 0.6rem;
  line-height: 0.6rem;
  text-align: center;
  color: #ffffff;
  background: -webkit-linear-gradient(30deg, #e5c48a, #dcb36a);
  background: -moz-linear-gradient(30deg, #e5c48a, #dcb36a);
  background: -o-linear-gradient(30deg, #e5c48a, #dcb36a);
  background: linear-gradient(30deg, #e5c48a, #dcb36a);
  font-size: 0.16rem;
  cursor: pointer;
  box-shadow: 0.01rem 0.09rem 0.16rem 0rem rgba(220, 181, 109, 0.39);
  border-radius: 0.05rem;
}
.applyBtn {
  text-align: center;
  font-size: 0.16rem;
  line-height: 0.2rem;
  margin-top: 0.46rem;
  color: #dcb46a;
  cursor: pointer;
}
.codeInput {
  display: flex;
}
.loginContent .codeImg {
  height: 0.4rem;
  display: inline-block;
  cursor: pointer;
  width: auto;
}
/deep/ .el-form-item{
  margin-bottom: 0.2rem;
}
/deep/.self-normalInput .el-form-item__content .input{
  height: 40px;
  .el-input__inner{
    height: 40px;
    font-size: 14px;
    line-height: 1.5;
    padding: 0px 7px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    box-sizing: border-box;
  }
  .el-button{
    height: 40px;
    font-size: 14px;
    line-height: 1.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/userLogin.vue